module.exports = __webpack_public_path__ + "static/media/stats.3fc33046.png";